export default __webpack_public_path__ + "static/media/sponsor-fandue-color.4a0aa091.png";